import { PaginationState } from "@tanstack/react-table";
import { clsx, type ClassValue } from "clsx";
import qs from "qs";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const buildPaginatedUrl = (
  baseUrl: string,
  pagination: PaginationState
): string => {
  const page = pagination.pageIndex + 1;
  const limit = pagination.pageSize;
  const query = qs.stringify({ page, limit });
  return `${baseUrl}?${query}`;
};
